"use client"

import styled from "styled-components"
import {
  Badge,
  Card,
  CardHeader,
  RadialGauge,
  SegBar,
  SegBarPart,
  Subtitle,
  Title,
  TitleGroup,
} from "./primitives"

const GaugeWrap = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const GaugeCaption = styled.p`
  margin: 0.5rem 0 0;
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--color-caution);
`

const GaugeScale = styled.div`
  margin-top: 0.75rem;
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 0.6875rem;
  color: var(--color-muted-foreground);
`

const social = [
  { label: "Bullish", value: 58, color: "var(--color-optimal)" },
  { label: "Neutral", value: 22, color: "var(--color-caution)" },
  { label: "Bearish", value: 20, color: "var(--color-alert)" },
]

const Legend = styled.div`
  margin-top: 1.25rem;
  display: flex;
  gap: 1.25rem;
`

const LegendItem = styled.div`
  display: flex;
  align-items: baseline;
  gap: 0.375rem;
`

const Value = styled.span`
  font-family: var(--font-mono);
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--color-card-foreground);
`

const Label = styled.span`
  font-size: 0.875rem;
  color: var(--color-muted-foreground);
`

const MetaRow = styled.p`
  margin: 1rem 0 0;
  font-size: 0.8125rem;
  color: var(--color-muted-foreground);
`

export function FearGreedCard() {
  return (
    <Card>
      <CardHeader>
        <TitleGroup>
          <Title>Fear &amp; Greed</Title>
          <Subtitle>Composite market emotion</Subtitle>
        </TitleGroup>
      </CardHeader>

      <GaugeWrap>
        <RadialGauge value={63} color="var(--color-caution)" size={160} />
        <GaugeCaption>Greed</GaugeCaption>
        <GaugeScale>
          <span>Extreme fear</span>
          <span>Extreme greed</span>
        </GaugeScale>
      </GaugeWrap>
    </Card>
  )
}

export function SocialSentimentCard() {
  return (
    <Card>
      <CardHeader>
        <TitleGroup>
          <Title>Social sentiment</Title>
          <Subtitle>142k posts analyzed · 24h</Subtitle>
        </TitleGroup>
        <Badge tone="optimal">Net bullish</Badge>
      </CardHeader>

      <Legend>
        {social.map((s) => (
          <LegendItem key={s.label}>
            <Value>{s.value}%</Value>
            <Label>{s.label}</Label>
          </LegendItem>
        ))}
      </Legend>

      <SegBar>
        {social.map((s) => (
          <SegBarPart key={s.label} $width={s.value} $color={s.color} role="presentation" />
        ))}
      </SegBar>

      <MetaRow>Mentions up 18% vs 7-day average</MetaRow>
    </Card>
  )
}

export default function SentimentCards() {
  return (
    <div style={{ display: "grid", gap: "1rem" }}>
      <SocialSentimentCard />
      <FearGreedCard />
    </div>
  )
}
